import CorpUserModel from './corpUser';
import JsSdkModel from './jssdk';
import AccountModel from './account';
import MemberFieldModel from './memberField';
import { configure } from 'mobx';

configure({ enforceActions: 'observed', useProxies: 'never' });

export const corpUserStore = new CorpUserModel();
export const jsSdkStore = new JsSdkModel();
export const accountStore = new AccountModel();
export const memberFieldStore = new MemberFieldModel();
